module.exports = __webpack_public_path__ + "img/image.f6246630.png";